import { adminApi } from '../../../../store/generated/admin/category';
import { UserContextApiTags } from '../../../../common/api/userContextApi';

const CategoryApiTags = {
  Category: 'Category',
} as const;

const taggedApi = adminApi.enhanceEndpoints({ addTagTypes: Object.values(CategoryApiTags) });

export const categoryApi = taggedApi.enhanceEndpoints({
  addTagTypes: [
    CategoryApiTags.Category,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1CategoryCreate: {
      invalidatesTags: [
        CategoryApiTags.Category,
        UserContextApiTags.OrganizationContext, // Affects demographic_fields
      ],
    },
    apiAdminV1CategoryPartialUpdate: {
      invalidatesTags: [
        CategoryApiTags.Category,
        UserContextApiTags.OrganizationContext, // Changes demographic field structure
      ],
    },
    apiAdminV1CategoryUpdate: {
      invalidatesTags: [
        CategoryApiTags.Category,
        UserContextApiTags.OrganizationContext, // Changes demographic field structure
      ],
    },
    apiAdminV1CategoryDestroy: {
      invalidatesTags: [
        CategoryApiTags.Category,
        UserContextApiTags.OrganizationContext, // Removes demographic field
      ],
    },
    apiAdminV1CategoryList: {
      providesTags: (result = []) =>
        result.map(cat => ({ type: CategoryApiTags.Category, id: cat.id })),
    },
    apiAdminV1CategoryRetrieve: {
      providesTags: (result, error, arg) => [
        { type: CategoryApiTags.Category, id: arg.id },
      ],
    },
  },
});

export type CategoryOption = {
  id: string;
  name: string;
  color: string;
  description: string;
  fr: string;
};


